module.exports = __webpack_public_path__ + "e27124e2090d177d23aed90543216e6e.svg";